import { isTiffPreviewPath } from "./tiffHelper";

export const IMAGE_FILE_RE = /\.(png|jpe?g|gif|webp|bmp|tiff?|svg|ico)(\?|$)/i;

class ImageHelper {
  static isImageContent(
    fileContent: string,
    fileContentType: string,
    fileName: string,
  ): boolean {
    const s = (fileContent || "").trim();
    if (!s) {
      return false;
    }

    if (isTiffPreviewPath(fileContent, fileName, fileContentType)) {
      return false;
    }

    const fileContentTypeLower = (fileContentType || "").toLowerCase();
    if (fileContentTypeLower.startsWith("image/")) {
      return true;
    }

    const fileNameLower = (fileName || "").toLowerCase();

    return (
      IMAGE_FILE_RE.test(fileNameLower) ||
      s.toLowerCase().startsWith("data:image/") ||
      (s.startsWith("blob:") && IMAGE_FILE_RE.test(fileNameLower)) ||
      (/^https?:\/\//i.test(s) && IMAGE_FILE_RE.test(s))
    );
  }

  static formatImageContent(
    fileContent: string,
    fileContentType?: string,
  ): string {
    const trimmedFileContent = (fileContent || "").trim();
    if (!trimmedFileContent) {
      return "";
    }

    // Blob / HTTP(S) / already-built data URLs are valid <img src> values; do not base64-wrap them.
    // (download API returns blob: URLs for binary images — wrapping breaks the preview.)
    if (
      /^(blob:|https?:\/\/)/i.test(trimmedFileContent) ||
      /^data:image\//i.test(trimmedFileContent)
    ) {
      return trimmedFileContent;
    }

    const fileContentTypeLower = (fileContentType || "image/png").toLowerCase();
    if (fileContentTypeLower.startsWith("image/")) {
      return `data:${fileContentTypeLower};base64,${trimmedFileContent.replace(/\s/g, "")}`;
    }

    return trimmedFileContent;
  }
}

export default ImageHelper;
